<style>
    .login-form{
        flex: 400px 0 0;
    }
    .login-form .el-form{
        width: 300px;
        margin: 85px auto 0;
    }
    .login-form .el-button--default{
        color: #F9AA3C;
        border-color: #F9AA3C;
    }
    .login-form .el-button--primary {
        background-color: #F9AA3C;
        border-color: #F9AA3C;
    }
    .login-form .el-button--primary:focus, 
    .login-form .el-button--primary:hover ,
    .login-form .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #E29A27;
        border-color: #F9AA3C;
    }
    .login-form .el-button--default:focus, 
    .login-form .el-button--default:hover,
     .login-form .el-checkbox__inner:hover {
        color: #E29A27;
        border-color: #F9AA3C;
    }
    .login-form .el-checkbox__inner:hover {

    }
    .login-form a {
        color: #48576a;
        font-size: 14px;
    }
    .login-form a:hover {
        text-decoration: underline;
    }
    .login-form .el-input-group__prepend,
    .login-form .el-input__inner {
        border: 0;
        border-bottom: 1px solid #bfcbd9;
        background-color: #fff;
    }
    .login-form .el-form-item.is-error .el-input-group__prepend {
        border-color: #ff4949;
    }
    .cover {
        position: relative;
    }
    .cover-title {
        margin: 10% 0 0 5%;
    }
    .cover-footer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: rgba(255,255,255,.2);
        padding: 10px 0;
    }
</style>
<template>
    <div class="flex f1 h100b">
        <div class="f1 cover">
            <div class="cover-title">
                <img src="../assets/img/title.png" alt="">
            </div>
            <div class="cover-footer">© 2017 luyishifu.com</div>
        </div>
        <div class="login-form">
            <el-form :model="formData" :rules="rules" ref="ruleForm">
                <h1 class="f28 bold c-blue">路易通管理系统</h1>

                <el-form-item prop="phone">
                    <el-input placeholder="请输入登录帐号" v-model="formData.phone" class="mt80">
                        <template slot='prepend'>
                            <i class="fa fa-user"></i>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="请输入登录密码" v-model="formData.password" class="mt10" @keyup.enter.native="loginSubmit">
                        <template slot='prepend'>
                            <i class="fa fa-lock"></i>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item class="mt20">
                    <el-button type="primary" 
                        :loading="isLoading" class="w100b" size="large"
                        @click="loginSubmit">登&nbsp;录&nbsp;</el-button>
                </el-form-item>
                <div class="flex center-ai mt20">
                    <a href="javascript:void(0);" title="点击找回密码" class="flex f1 f12 c-gray">
                       忘记密码？
                    </a>
                    <el-checkbox v-model="checked">记住我</el-checkbox>
                </div>
                <ly-line txt="or" class="mt40"></ly-line>
                <div class="mt40">
                    <el-button class="w100b" size="large" @click="toErp">进入信息化端</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import LyLine from '@c/line'

    export default {
        data () {
            return {
                isLoading: false,
                checked: true,
                formData: {
                    phone: '',
                    password: '',
                    remember: 'on'
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入登录账号', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入登录账号', trigger: 'blur'},
                        { min: 6, message: '长度不少于 6 个字符', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            LyLine
        },
        methods: {
            ...mapActions([
                'updateTokon',
                'updateAuthorizd'
            ]),
            loginSubmit () {
                this.$refs['ruleForm'].validate((valid) => {
                    this.isLoading = valid
                })
                if (!this.isLoading) return false
                // 设置remember的值
                this.formData.remember = this.checked ? 'on' : 'off'
                // 登录请求
                this.$api.login.submit(this.formData).then((rs) => {
                    this.isLoading = false
                    // 1、将tokon存放到vuex中
                    this.updateTokon(rs.tokon)
                    // 2、本地存储tokon
                    this.$utils.saveTokon(rs.tokon)
                    // 3、改变authorizd状态
                    this.updateAuthorizd(true)
                    // 4、路由跳转到默认页面
                    this.$router.replace('/')
                }).catch((error) => {
                    this.isLoading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 跳转到erp
             */
            toErp () {
                // erp地址为当前的域名根路径
                location.href = '//' + location.host
            }
        }
    }
</script>